// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2jrLX","label":"CategoryService_label__iPKlq","location":"CategoryService_location__1JZAk"};